import * as React from 'react'

const Close = ({ className }: { className: string }) => (
  <svg viewBox="0 0 49 50" className={className}>
    <path
      d="M49 45.71l-3.55 3.571-20.6-20.713L3.54 49.997l-3.55-3.572L21.3 24.997-.01 3.57 3.54-.002l21.31 21.427L45.45.713 49 4.284 28.4 24.997"
      fill="#fff"
    />
  </svg>
)

export default Close
